import { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Form, Stack } from 'react-bootstrap';
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { FcPlus, FcList } from "react-icons/fc";
import { TiEdit } from "react-icons/ti";

import { fileFormatList } from '../../constant/index';
import SupplierDataService from "../../services/supplier.service";
import ProjectDataService from "../../services/project.service";
import FormInputText from "../../components/FormField/FormInput";
import FormSelect from "../../components/FormField/FormSelect";
import { useAuthContext } from "../../contexts/AuthContext";

import "./Supplier.scss";


function SupplierCreate() {

  const navigate = useNavigate();
  const location = useLocation();

  let { projectId, supplierId } = useParams();
  const { setIsLoading } = useAuthContext();

  const [supplierName, setSupplierName] = useState("");
  const [supplierCode, setSupplierCode] = useState("");
  const [supplierERP, setSupplierERP] = useState("");
  const [supplierAddress, setSupplierAddress] = useState("");
  const [supplierFileLocation, setSupplierFileLocation] = useState(false);
  const [serverPath, setServerPath] = useState("");
  const [serverUserName, setServerUserName] = useState("");
  const [serverPassword, setServerPassword] = useState("");
  const [serverPortNumber, setServerPortNumber] = useState("");
  const [serverFolderPath, setServerFolderPath] = useState("");
  const [fileFormat, setFileFormat] = useState("");
  const [fileFormatSelected, setFileFormatSelected] = useState("");
  const [project, setProject] = useState("");
  const [supplier, setSupplier] = useState("");
  const [metaDataFieldName, setMetaDataFieldName] = useState();
  const [metaDataFieldValue, setMetaDataFieldValue] = useState();
  const [metadata, setMetadata] = useState([]);
  const [showMetadata, setShowMetadata] = useState(false);

  const isEdit = (supplierId && location && location.pathname && location.pathname.includes('/edit')) ? true : false;
  const isView = (supplierId && location && location.pathname && !location.pathname.includes('/edit')) ? true : false;
  const isCreate = (!supplierId) ? true : false;


  useEffect(() => {
    retrieveProjectDetails();
  }, [])

  function retrieveProjectDetails() {
    setIsLoading(true);
    ProjectDataService.get(projectId).then((response) => {
      setIsLoading(false);
      setProject(response.data.data);
    });
  }

  useEffect(() => {
    console.log('supplierId', supplierId);
    retrieveSupplierDetails(supplierId);
  }, [projectId, supplierId]);

  useEffect(() => {
    if(supplier){
      setSupplierName(supplier.supplierName);
      setSupplierCode(supplier.supplierCode);
      setSupplierERP(supplier.supplierERP);
      setSupplierAddress(supplier.supplierAddress);
      setProject(supplier.projectId);
      setSupplierFileLocation(supplier.supplierFileLocation);
      setServerPath(supplier.serverPath);
      setServerUserName(supplier.serverUserName);
      setServerPassword(supplier.serverPassword);
      setServerPortNumber(supplier.serverPortNumber);
      setServerFolderPath(supplier.serverFolderPath);
      setMetadata(supplier.metadata);
      setFileFormat(supplier.fileFormatType);
      setFileFormatSelected(supplier.fileFormatType);
    }
  }, [supplier]);

  function retrieveSupplierDetails(supplierId) {
    setIsLoading(true);
    SupplierDataService.get(supplierId).then((response) => {
      setIsLoading(false);
      setSupplier(response.data.data);
    });
  }

  const createEditSupplier = () => {

    if(!projectId) {
      toast.warning("Project is required.");
      return true;
    }

    var data = {
      projectId,
      supplierName,
      supplierCode,
      supplierERP,
      supplierAddress,
      supplierFileLocation,
      serverPath,
      serverUserName,
      serverPassword,
      serverPortNumber,
      serverFolderPath,
      metadata,
      fileFormatType: fileFormatSelected
    }; 

    if(isEdit){
      setIsLoading(true);
      SupplierDataService.update(supplierId, data).then((response) => {
        setIsLoading(false);
        console.log('response', response);
        if(response.data.success){
          toast.success("Supplier Updated!");
          navigate("/project/" + projectId + "/supplier");
        } else {
          toast.error("Error in updating supplier");
        }
        
      });
    } else if(isCreate){
      setIsLoading(true);
      SupplierDataService.create(data).then((response) => {
        setIsLoading(false);
        console.log('response', response);
        if(response.data.success){
          toast.success("Supplier Created!");
          navigate("/project/" + projectId + "/supplier");
        } else {
          toast.error("Error in creating supplier");
        } 
      });
    }
  };

  const onChangeMMetadataFieldValue = (value, name) => {
    let updatedMetadata = metadata.filter(function (item) {
      if(item.metadataName === name){
       return item;
      }
    });
    updatedMetadata[0].metadataValue = value;

    setMetadata([...metadata], updatedMetadata);
  }

  const addMetaData = () => {
    setShowMetadata(!showMetadata);
  }

  const handleAddMetaData = () => {
    let metadataArray = metadata.length > 0 ? [...metadata] : [];
    metadataArray.push({
        metadataName: metaDataFieldName,
        metadataValue: metaDataFieldValue
    });
    setMetadata(metadataArray);
    setMetaDataFieldName("");
    setMetaDataFieldValue("");
  }

  const setFileFormatFunction  = (value, name) => {
    const selectedFileFormat = fileFormatList.filter((item) => item.name === value);
    console.log(selectedFileFormat);
    console.log(value);
    setFileFormat({
      name: value,
      id: value,
    });
    //setFileFormat(value);
    setFileFormatSelected(value);
  }


  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 mb-2 pageTitle">{isEdit ? 'Edit' : isView ? 'View' : 'Create New'} Supplier</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={2}>
          <Button
            className="btn btn-light mt-4"
            theme="accent"
            onClick={() => navigate(`/project/${projectId}/supplier`)}
          >
            <FcList /> View All
          </Button>

          {!isView && (
            <Button
              className="btn btn-primary mt-4"
              theme="accent"
              onClick={() => addMetaData()}
            >
              <FcPlus /> Add MetaData
            </Button>
          )}
          </Stack>
          
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <Form>
            <Row>
              <Col md="12" className="form-group">
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Project Country</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {project && project.country}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Project Asset Code</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {project && project.assetCode}
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Supplier Name</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      supplierName
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Supplier Name"
                          value={supplierName}
                          setFunc={setSupplierName}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Supplier Code / ID</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      supplierCode
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Supplier Code"
                          value={supplierCode}
                          setFunc={setSupplierCode}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Supplier ERP / Group</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      supplierERP
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Supplier ERP"
                          value={supplierERP}
                          setFunc={setSupplierERP}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Format Type</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormatSelected
                    ) : (
                      <FormSelect
                        className="forminput"
                        placeholder="Select Format"
                        optionList={fileFormatList}
                        value={fileFormatSelected}
                        setFunc={setFileFormatFunction}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Supplier Address</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      supplierAddress
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Supplier Address"
                          value={supplierAddress}
                          setFunc={setSupplierAddress}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Supplier File Location</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      supplierFileLocation === true ? 'YES' : 'NO'
                    ) : (
                      <BootstrapSwitchButton
                        checked={supplierFileLocation}
                        id="supplierFileLocation"
                        onlabel='Yes'
                        offlabel='No'
                        onChange={setSupplierFileLocation}
                      />
                    )}
                  </Col>
                </Row>
                {supplierFileLocation && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">
                        File Location Configuration
                      </label>
                    </Col>
                    <Col className="form-field" md="8">
                      <Row>
                        <Col className="form-field" md="9">
                          {isView ? (
                            `server path: ${serverPath}`
                          ) : (
                          <FormInputText
                            id="serverPath"
                            placeholder="Server Path"
                            value={serverPath}
                            setFunc={setServerPath}
                            showLabel={false}
                          />
                          )}
                        </Col>
                        <Col className="form-field" md="3">
                          {(isView) ? (
                            `server port: ${serverPortNumber}`
                          ) : (
                            <FormInputText
                              id="serverPortNumber"
                              placeholder="Port"
                              type="number"
                              value={serverPortNumber}
                              setFunc={setServerPortNumber}
                              showLabel={false}
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `server user name: ${serverUserName}`
                          ) : (
                            <FormInputText
                              id="serverUsername"
                              placeholder="Server User Name"
                              value={serverUserName}
                              setFunc={setServerUserName}
                              showLabel={false}
                            />
                          )}
                        </Col>
                        {(!isView) && (
                          <Col className="form-field" md="6">
                              <FormInputText
                                id="serverPassword"
                                type="password"
                                placeholder="Server Password"
                                value={serverPassword}
                                setFunc={setServerPassword}
                                showLabel={false}
                              />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col className="form-field" md="12">
                          {(isView) ? (
                            `server folder path: ${serverFolderPath}`
                          ) : (
                            <FormInputText
                              id="folderPath"
                              placeholder="Folder Path"
                              value={serverFolderPath}
                              setFunc={setServerFolderPath}
                              showLabel={false}
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                {metadata && metadata.map((mdItem, mdIndex) => {
                    return (
                      <Row className="form-group-row border-bottom-button ml-2 mr-2"  key={`metadata-${mdIndex} + 1`}>
                        <Col className="form-label" md="4">
                          {mdItem.metadataName}
                        </Col>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `${mdItem.metadataValue}`
                          ) : (
                            <FormInputText
                                id={`metadataValue-${mdIndex}`}
                                placeholder="Metadata Value"
                                name={mdItem.metadataName}
                                value={mdItem.metadataValue}
                                setFunc={onChangeMMetadataFieldValue}
                                showLabel={false}
                              />
                          )}
                          </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                    );
                })}

                {showMetadata && !isView && (
                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                    <Col className="form-field" md="12">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          Meta Data Name:
                        </Col>
                        <Col className="form-field" md="6">
                          Meta Data Value:
                        </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                            <FormInputText
                              id="metadataName"
                              placeholder="Metadata Name"
                              value={metaDataFieldName}
                              setFunc={setMetaDataFieldName}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="6">
                            <FormInputText
                              id="metadataValue"
                              placeholder="Metadata Value"
                              value={metaDataFieldValue}
                              setFunc={setMetaDataFieldValue}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="2">
                          <Button variant="primary" onClick={() => handleAddMetaData()}>
                              {/* <FcPlus size="16" />  */}
                              Add 
                            </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}



                {(isEdit || isCreate) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => createEditSupplier()}
                        >
                          <FcPlus /> { isEdit ? 'Update' : 'Create' } Supplier
                        </Button>
                    </Col>
                  </Row>
                )}

                {(isView) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => navigate(`/project/${projectId}/supplier/${supplierId}/edit`)}
                        >
                          <TiEdit /> Edit Supplier
                        </Button>
                    </Col>
                  </Row>
                )}

              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      
      
    </Container>
  );
}

export default SupplierCreate;
